export default "__VITE_ASSET__Q$K4O5br__"